<!--
  - Copyright (c) 2021 brightlamp
  -->

<template>
    <div>
        <v-dialog v-model="dialogLocal" scrollable max-width="540px">
            <v-card>
                <v-card-title>
                    <span class="headline" align="center" style="color:#FFFD00;background-color:#363636;width:100%;display:block;">Patient Search</span>
                </v-card-title>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn color="blue darken-1" text @click="closeDialog(null)">Cancel</v-btn>
                </v-card-actions>
                <v-card-text class="mt-n5">
                    <v-row>
                        <v-col xs=1>
                            <v-btn class="mt-4" @click="newPatientData" color="accent">
                                <span style="color: #000000;">New Patient</span>
                            </v-btn>
                        </v-col>
                        <v-col xs=11>
                            <v-checkbox
                                type="checkbox"
                                true-value="true"
                                label="See Organization Patients"
                                v-model="seeOrganizationTestsComputed"
                                color="primary"
                                v-if="currentUser && currentUser.orgId"
                                @change="seeOrganizationTestsToggle"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col xs=12>
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Search by Patient ID, Group ID, or Name"
                                single-line
                                hide-details
                                clearable
                                @click:clear="handleClearSearch"
                                v-debounce:300="handleSearch">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col xs=12>
                            <v-card tile flat class="blue lighten-1 pa-1" :height="598">
                                <v-card tile flat :height="590">
                                    <v-card tile flat>
                                        <v-data-table
                                            :headers="headers"
                                            :items="mrns"
                                            item-key="id"
                                            @click:row="rowSelected"
                                            :options.sync="pagination"
                                            :server-items-length="totalRecords"
                                            :loading="waiting"
                                            :footer-props="{'items-per-page-options':[10]}"
                                            @update:options="loadItems">
                                        </v-data-table>
                                    </v-card>
                                </v-card>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <PatientDataDialog :dialog="patientDataDialog" :newPatient="newPatient" @dialog-close="patientDataDialogClose"/>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import PatientDataDialog from '@/components/patient-data-dialog';

    export default
    {
        name: 'patient-search-dialog',
        components:
        {
            PatientDataDialog
        },
        data: function ()
        {
            return {
                dialogLocal: false,
                pagination: {page: 1, itemsPerPage: 10},
                search: '',
                headers:
                [
                    {
                        text: 'Patient ID',
                        value: 'mrn',
                        sortable: false
                    },
                    {
                        text: 'Name',
                        value: 'name',
                        sortable: false
                    },
                    {
                        text: 'Age',
                        value: 'age',
                        sortable: false
                    }
                ],
                selectedPatient: null,
                patientDataDialog: false,
                newPatient: false
            }
        },
        computed:
        {
            ...mapState('auth',
            {
                currentUser: state => state.currentUser,
                seeOrganizationTests: state => state.seeOrganizationTests,
                searchValue: state => state.searchValue
            }),
            ...mapState('mrns',
            {
                mrns: state => state.mrns,
                totalRecords: state => state.totalRecords
            }),
            ...mapState('tests',
            {
                patientData: state => state.patientData
            }),
            ...mapState('common',
            {
                waiting: state => state.waiting
            }),
            seeOrganizationTestsComputed:
            {
                get: function ()
                {
                    return this.seeOrganizationTests
                },
                set: function (newValue)
                {
                    this.SET_SEE_ORGANIZATION_TESTS(newValue);
                    this.currentUser.preferences.seeOrganizationTests = newValue;
                    this.UPDATE_CURRENT_USER_NO_WAIT(this.currentUser)
                }
            }
        },
        props:
        {
            dialog: Boolean(false)
        },
        watch:
        {
            async dialogLocal(val)
            {
                // If the dialog is being closed
                if (!val)
                {
                    this.search = '';
                    this.$emit('dialog-close', this.selectedPatient)
                }
                else // Else the dialog is being opened
                {
                    this.$logEvent(this.$firebaseAnalytics, 'screen_view',
                    {
                        app_name: 'Web Portal',
                        screen_name: `Reflex Web Portal - ${this.$options.name}`,
                        app_version: process.env.VUE_APP_VERSION
                    });
                    this.selectedPatient = null;
                    await this.loadItems()
                    this.dialogLocal = val
                }
            },
            dialog(val)
            {
                this.dialogLocal = val
            },
            search(val)
            {
                this.SET_SEARCH_VALUE(val)
            }
        },
        methods:
        {
            ...mapActions('mrns', ['GET_MRNS']),
            ...mapMutations('auth', ['SET_SEE_ORGANIZATION_TESTS', 'SET_SEARCH_VALUE']),
            ...mapActions('auth', ['UPDATE_CURRENT_USER_NO_WAIT']),
            ...mapMutations('tests', ['INIT_PATIENT_DATA']),
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            async handleSearch()
            {
                await this.loadItems()
            },
            async handleClearSearch()
            {
                this.search = '';
                await this.loadItems()
            },
            rowSelected(item)
            {
                this.closeDialog(item)
            },
            async loadItems()
            {
                try
                {
                    this.HIDE_SNACKBAR();
                    this.WAITING(true);
                    await this.GET_MRNS({pagination: this.pagination, search: this.search, userOnly: !this.seeOrganizationTests})
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.message)
                }
                this.WAITING(false)
            },
            closeDialog(selectedPatient)
            {
                this.selectedPatient = selectedPatient;
                this.HIDE_SNACKBAR();
                this.dialogLocal = false
            },
            async seeOrganizationTestsToggle()
            {
                await this.loadItems()
            },
            newPatientData()
            {
                this.INIT_PATIENT_DATA();
                this.newPatient = true;
                this.patientDataDialog = true
            },
            async patientDataDialogClose(payload)
            {
                this.patientDataDialog = false
                if (payload)
                {
                    this.closeDialog(this.patientData)
                }
            }
        }
    };
</script>

<style scoped>
</style>